import React, { FormEvent, useState } from "react";
import { api } from "shared/api";
import { useApiMethod, UseModalProps } from "shared/lib";
import { Input, LoadingDots, Modal, Error } from "shared/ui";

export interface IDepositTypeCreateModal extends UseModalProps {
  companySlug: string;
}

export const DepositTypeCreateModal = (props: IDepositTypeCreateModal) => {
  const depositTypeList = api.depositType.useDepositTypeList(props.companySlug);
  const submit = useApiMethod(api.depositType.depositTypeCreate);

  const [name, setName] = useState("");

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!name) return;

    await submit.call(props.companySlug, { name });
    await depositTypeList.mutate();
    await props.onSuccess();
  };

  return (
    <Modal onClose={props.close} width={400}>
      <form onSubmit={onSubmit}>
        <Modal.Header>
          <Modal.Title>Новый источник внедоходных поступлений</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Input autoFocus placeholder="Название" value={name} onChange={(e) => setName(e.target.value)} />

          {submit.error && <Error style={{ marginTop: 24 }}>{submit.error.message}</Error>}
        </Modal.Body>

        <Modal.Actions>
          <Modal.Action htmlType="button" onClick={props.close}>
            Назад
          </Modal.Action>

          <Modal.Action htmlType="submit" disabled={submit.loading}>
            {!submit.loading ? "Создать" : <LoadingDots size={4}>Создаем</LoadingDots>}
          </Modal.Action>
        </Modal.Actions>
      </form>
    </Modal>
  );
};

DepositTypeCreateModal.defaultProps = {};
